import React, { FC } from 'react'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'

import { SwitchBasedFilter } from './FiltersVariations/Switch'

interface DepositsOnHoldFilterProps extends FiltersSharedProps {
  initialValue?: boolean
  onChange: (value?: boolean) => void
}

export const DepositsOnHoldFilter: FC<DepositsOnHoldFilterProps> = props => {
  return <SwitchBasedFilter title="Deposits on Hold" {...props} />
}
